import { FlightError } from "@b2bportal/air-booking-api";
import { PurchaseErrorEnum, Product } from "@b2bportal/purchase-api";
import { PurchaseErrorForm } from "./PurchaseErrorForm";
import type { FormComponentMap, EndpointKey, Responses } from "./types";

export const initResponses: Responses = {
  "/api/v1/purchase/quote/schedule": {
    enabled: false,
    errorCode: 500,
    response: undefined,
  },
  "/api/v1/purchase/quote/poll": {
    enabled: false,
    errorCode: 200,
    response: {
      QuoteResponse: "Failure",
      errors: [
        {
          Error: PurchaseErrorEnum.ProductError,
          value: {
            type: Product.Flight,
            value: FlightError.Unknown,
          },
        },
      ],
    },
  },
  "/api/v1/purchase/quote/update": {
    enabled: false,
    errorCode: 500,
    response: undefined,
  },
  "/api/v1/purchase/fulfill/schedule": {
    enabled: false,
    errorCode: 500,
    response: undefined,
  },
  "/api/v0/paymentMethods/pollInteractiveAuth": {
    enabled: false,
    errorCode: 200,
    response: {
      InteractiveAuthResponse: "Failure",
      errors: [
        {
          Error: PurchaseErrorEnum.PaymentError,
          tags: {},
          value: {
            type: "Card",
            value: "",
          },
        },
      ],
    },
  },
  "/api/v1/purchase/fulfill/poll": {
    enabled: false,
    errorCode: 200,
    response: {
      FulfillResponse: "Failure",
      errors: [
        {
          Error: PurchaseErrorEnum.ProductError,
          value: {
            type: Product.Flight,
            value: FlightError.Unknown,
          },
        },
      ],
    },
  },
};

export const formComponentMap: FormComponentMap = {
  "/api/v1/purchase/quote/schedule": undefined,
  "/api/v1/purchase/quote/poll": PurchaseErrorForm,
  "/api/v1/purchase/quote/update": undefined,
  "/api/v1/purchase/fulfill/schedule": undefined,
  "/api/v0/paymentMethods/pollInteractiveAuth": undefined,
  "/api/v1/purchase/fulfill/poll": PurchaseErrorForm,
};

export const endpoints = Object.keys(initResponses) as EndpointKey[];
